import axios from "axios";

export const validateCC = (value) => {
  const v = value
    .replace(/\s+/g, "")
    .replace(/[^0-9]/gi, "")
    .substr(0, 16);
  const parts = [];

  for (let i = 0; i < v.length; i += 4) {
    parts.push(v.substr(i, 4));
  }

  return parts.length > 1 ? parts.join(" ") : value;
};

export const callAPI = async (url, method, data, params, headers = null) => {
  const response = await axios({
    url: url,
    method: method,
    data,
    params,
    headers: headers || { "Content-Type": "application/json" },
  });
  return response.data;
};

export const handleDecodeURL = (param) => {
  if (!param) return "";
  try {
    const result = decodeURIComponent(param);
    return result;
  } catch (e) {
    return "";
  }
};

export const getFullDomain = () => {
  const protocol = window.location.protocol;
  const domain = window.location.hostname;
  const port = window.location.port ? `:${window.location.port}` : '';
  return `${protocol}//${domain}${port}`;
};

export function urlSearchParamsToObject(urlSearchParams, props) {
  const params = props ?? {};
  urlSearchParams.forEach((value, key) => {
    params[key] = value;
  });
  return params;
}